export const checkCredentials = () => {
    if (
        sessionStorage.getItem("hooliToken") &&
        sessionStorage.getItem("sessionId")
    ) {
        return {
            hooliToken: sessionStorage.getItem("hooliToken"),
            sessionId: sessionStorage.getItem("sessionId"),
        };
    }
    return null;
};

export const checkAuth = () => {
    return (
        sessionStorage.getItem("hooliToken") &&
        sessionStorage.getItem("sessionId")
    ) ? true : false;
};
